module.exports = __webpack_public_path__ + "img/OtherPickingS1Page.518bd714.png";